<template>
  <v-app-bar class="main-header" height="60" fixed color="primary" dark>
    <v-app-bar-nav-icon @click.stop="drawerChange"></v-app-bar-nav-icon>

    <v-img 
      max-height="36" 
      max-width="120" 
      class="logo"
      :src="logo"
    />    
    <v-divider
      vertical
      inset
      />

    <v-img v-if="biggLogoShow"
      max-height="36" 
      max-width="120" 
      class="logo ml-2"
      :src="distributorLogoLink"
    /> 
    <v-toolbar-title>
      <div class="title overline font-weight-regular">
        Control
      </div>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">
          <v-icon small class="mr-1">mdi-web</v-icon>
          {{ currentLanguage }}
          <v-icon small>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(language, index) in languages" :key="index" @click="updateLanguage(language)">
          <v-list-item-title>{{ $t(language) }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-divider
        vertical
        inset
      />
    <v-menu v-if="portalAccess" min-width="180" offset-y bottom left nudge-bottom="10">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mr-0" icon v-bind="attrs" v-on="on">
          <!-- <v-icon style="font-size: 28px" :color="config.light.iconColor">mdi-home-variant-outline</v-icon> -->
          <v-icon style="font-size: 28px" :color="config.light.iconColor">mdi-home-switch-outline</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item-group color="primary">
          <v-list-item @click="openLink(portalUrl)">
            <v-list-item-icon class="mr-4">
              <v-icon style="font-size: 28px" :color="config.light.textColor">mdi-monitor-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                :color="config.light.textColor"
              >
                domX Portal
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-divider
      vertical
      inset
    />
    <v-menu min-width="180" offset-y bottom left nudge-bottom="10">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mr-0" icon v-bind="attrs" v-on="on">
          <v-icon style="font-size: 28px" :color="config.light.iconColor"
            >mdi-account</v-icon
          >
        </v-btn>
      </template>
      <v-list>
        <div class="text-h5 grey--text text--darken-3 px-4 pt-4">{{user.name}}</div>
        <div class="d-flex justify-center my-3">
          <v-btn
            width="80%"
            large
            outlined
            color="error"
            class="text-capitalize"
            @click="logOut"
            >{{ $t('logout') }}
          </v-btn>
        </div>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import config from "../../config";
import { commonModule, statsModule, companyModule } from '@/store/modules/store-accessor'
import KeycloakSession from '@/helpers/keycloak-session'
import { syncDocumentLanguage } from '@/helpers/documentLanguage'

@Component
export default class Header extends Vue {
  currentLanguage = localStorage.getItem("lang") || "el";
  languages = ["el", "en"];

  updateLanguage(language: any) {
      this.currentLanguage = language;
      localStorage.setItem("lang", this.currentLanguage);
      syncDocumentLanguage(this.currentLanguage);
      this.$router.go(0); // Reload the whole app/page
    }

  get logo() {
    return require("@/assets/img/new_logo_domX.png")
  }

  get biggLogoShow() {
    if (companyModule.company.email == 'info@domx.io') {
      return true;
    }
    
    return false; 
  }

  get distributorLogoLink() {
    // return companyModule.company.distributor_logo_link;
    if(this.isDistributor) {
      return companyModule.company.company_logo_link;
    }
    else {
      return companyModule.company.distributor_logo_link;
    }
  }

  get kcSession() {
    return new KeycloakSession()
  }

  get isDistributor() {
    return this.kcSession.userHasRole('distributor');
  }

  get isTechnicianCompany () {
    return this.kcSession.userHasRole('technician_company');
  }

  get config() {
    return config;
  }

  get user() {
    return commonModule.user;
  }

  get portalAccess() {
    return commonModule.portalAccess;
  }

  get portalUrl () {
    return (process.env.NODE_ENV === 'production' ? 'PORTAL_URL' : 'https://portal.business.domx-dev.com/')
  }

  logOut() {
    commonModule.showModal({ name: 'log-out-modal' })
  }

  drawerChange() {
    statsModule.changeDrawerState();
  }

  openLink (link: string) {
      window.open(link, '_blank');
  }

}
</script>

<style lang="scss">
@import "../../styles/app";

.main-header {
  .v-list {
    .v-list-item:hover {
      background-color: #f3f5ff;
      &:before {
        opacity: 0;
      }
    }
    .v-list-item:hover .v-list-item__icon {
      .v-icon {
        color: rgba($primary, 0.8) !important;
      }
    }
    .link-item {
      cursor: pointer;
    }
  }
  .v-btn:hover:before {
    top: 2px;
    left: 2px;
    bottom: 2px;
    right: 2px;
  }
}

.logo {
  margin-right:20px;
}
.title {
  margin-left: 20px;
}

</style>
